import { useDropdownState } from '../abstract/dropdown';

export function useBathroomFilter({
  config,
  query,
  setFilters,
  updateQuery,
}) {
  let { selected: bathroom, onSelect: onBathroomSelect, options: bathroomOptions } = useDropdownState({
    defaultOptions: config.bathroomOptions,
    defaultValue: query.bathroom || config.bathroomDefault,
    filterKey: `baths`,
    setFilters,
    updateQuery,
  });

  return { bathroom, bathroomOptions, onBathroomSelect };
}
